import { Component, OnInit, ElementRef, NgZone, AfterViewInit } from '@angular/core';
import { PermissionPipe } from '@shared/pipes/permission';
import { TabOpenService } from '@services/tab-open.service';
import { ActionName } from '@shared/enums/action-name';
import { Tabs } from '@enums/tab.enum';
import { DataService } from '@shared/services/kendo-grid-data';
import { CustomerService } from '@fs/services/customer';
import { ExportColumnHeaders } from '@shared/models/export-headers.model';
import { MapExportData } from '@shared/data/MapExportData';
import { CommonMethods } from '@services/common.method';
import { SpinnerService } from 'src/app/shared/services/spinner.service';
import { Constants } from 'src/app/shared/models/constants';
import { Grid } from '@fs/enums/grid.enum';
import { GridFilter } from '@fs/services/grid.mixin';
import { customJS } from '@fs/services/customjs';
import { catchError, debounceTime, switchMap, takeUntil } from 'rxjs/operators';
import { of } from 'rxjs';
import { ExportType } from "@fs/enums/common-enums";
import { ExportService } from '@shared/services/export.service';

@Component({
  selector: 'app-cust-manage',
  templateUrl: './cust-manage.component.html',
  styleUrls: ['./cust-manage.component.scss'],
  providers: [DataService, CustomerService]
})
export class CustManageComponent extends GridFilter implements OnInit, AfterViewInit {
  customerID: string = "";
  jobsiteID: string = "";
  detailData: any;
  openWorkOrder: boolean;
  openJobSite: boolean;
  actionName = ActionName;
  enableJobsiteCountSort: boolean = false;
  qbVersion: string; 
  showNoRecord: boolean = false;
  hasWorkOrderManagePermission: boolean = true;
  selectType: string = "Jobsite";

  constructor(private $elementRef: ElementRef, private customerServ: CustomerService, private exportServ: ExportService,
    private tabopen: TabOpenService, private zone: NgZone, spinnerServ: SpinnerService, private permissionPipe: PermissionPipe,
    private commonMethod: CommonMethods) { 
      super(Grid.JobSite, spinnerServ);
      //ToDo: Optimizing further requires significant changes in the exisitng services
      this.makeRequest$.pipe(
        debounceTime(Constants.debounceInterval),
        switchMap((val:string) => 
        this.customerServ.GetCustomerLanding(this.selectType, this.isExport? this.getExportState() : this.state, val).pipe(
        catchError(() => {
          return of({ Data: [], Count: 0 });
        })
      )), 
      takeUntil(this.ngUnsubscribe))
      .subscribe(r => {
        this.spinnerServ.hideLoader(this.gridVc, this.tabCounter);
        if (!this.isExport) this.mapGridData(r); else this.mapExportData(r); 
      });
  }

  ngOnInit() {
    this.load();
  }
  ngAfterViewInit() {
    this.zone.runOutsideAngular(() => {
      customJS.setScroll(this.$elementRef.nativeElement);
    });
  }
  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
  openNewCustomerTab() {
    if (!this.permissionPipe.transform(ActionName.CreateCustomer))
      return;
    this.tabopen.OpenTab(
      {
        tabId: Tabs.FsLiteNewCustomer,
        params: {},
        tabTitle: 'New Customer'
      }
    )
  }
  openNewWorkOrderTab(data) {
    this.openWorkOrder = true;
    this.previewDetail(data);
  }
  createNewEstimate(data) {
    let params = Object.assign({},data);
    params["TaxGroup"] = {  ID: data.TaxGroupID   };
    if (!this.permissionPipe.transform(ActionName.AddEstimate))
      return;
    this.tabopen.OpenTab(
      {
        tabId: Tabs.NewEstimate,
        params: { Customer: data.Customer, JobSite:params   },
        tabTitle: 'New Estimate'
      }
    )
  }
  openJobSiteViewTab(data) {
    this.openJobSite = true;
    this.previewDetail(data);
  }
  jobSiteMarker(): string {
    let hightlightStr: string = "";
    if (this.selectType == "Jobsite") {
      hightlightStr = this.filterForm.controls['searchString'].value;
    }
    return hightlightStr
  }
  customerMarker(): string {
    let hightlightStr: string = "";
    if (this.selectType == "Customer") {
      hightlightStr = this.filterForm.controls['searchString'].value;
    }
    return hightlightStr
  }
  openWorkOrderViewTab(workOrderId, WorkTicketNo, jobSiteID, customerID) {
    let params = {
      ID: workOrderId,
      customerId: customerID,
      jobsiteId: jobSiteID
    }
    this.tabopen.OpenTab({
      tabId: Tabs.FsLiteWorkOrderView,
      params: params,
      tabTitle: WorkTicketNo
    })
  }
  applyFilter(filterSetting: { applyAdvanceFilter: boolean, advanceFilterActive: any } = { advanceFilterActive: true, applyAdvanceFilter: null }, isStateReset: boolean = false) {
    let filterValues = this.filterForm.controls['searchFilters'];
    let filters = jQuery.extend(true, {}, filterValues);
    filters.value.map(x => {
      if (x.field != "" && x.field.split('.').length < 2) {
        if (x.field=="ActiveAgreement") { if (!x.value) { x.field = x.field+"#"; x.operator = "neq"; }; x.value = "active"; }
        x.field = this.selectType + "." + x.field;
      }
    });
    this.filter(filterSetting, filters);
  }
  //#region private methods 
  private load() {
    this.spinnerServ.showloader(this.gridVc, this.tabCounter, Constants.defaultSpinnertimeout, true);
    this.getData();
  }
  private previewDetail(data) {
    this.customerID = data.Customer.ID;
    this.jobsiteID = data.ID;
    this.getPreviewData(data);
  }
  private getPreviewData(data) {
    if (this.customerID != undefined && this.customerID != "") {
      this.spinnerServ.showloader(this.gridVc, this.tabCounter);
      this.customerServ.GetJobSiteDetail(this.customerID, this.jobsiteID, "Customer,TaxGroup,Contacts,PaymentTerm").subscribe(response => {
        if (response != null) {
          if (response.Customer != null) {
            this.detailData = response.Customer;
            response.Customer = null;
          }
          this.detailData.JobSites = [response];
          if (this.openWorkOrder && this.permissionPipe.transform(ActionName.NewWorkOrder)) {
            this.tabopen.OpenTab(
              {
                tabId: Tabs.FsLiteWorkOrderCreate,
                params: { data: this.detailData },
                tabTitle: 'New Work Order'
              });
          }
          else if (this.openJobSite) {
            let customerData = Object.assign({}, this.detailData);
            customerData.JobSites = [];
            this.tabopen.OpenTab({
              tabId: Tabs.FsLiteCustomerJobSiteEdit,
              params: {
                ID: this.jobsiteID,
                jobsiteId: this.jobsiteID,
                objDetailData: customerData,
                previewType: this.selectType == "Customer" ? "Billing" : "Jobsite"
              },
              tabTitle: "Job Site - " + data.DisplayName,
              replaceIfOpen: {
                replaceTab: true,
                tabToReplace: Tabs.FsLiteCustomerJobSiteEdit,
                action: "focus"
              }
            });
          }
        }
        this.spinnerServ.hideLoader(this.gridVc, this.tabCounter);
        this.openJobSite = false;
        this.openWorkOrder = false;
      }, error => {
        this.spinnerServ.hideLoader(this.gridVc, this.tabCounter);
        this.openJobSite = false;
        this.openWorkOrder = false;
      });
    }
  }
  private async mapExportData(r) {
    this.isExport = false;
    let columns = ExportColumnHeaders.CustManageColumns.filter(x => (this.qbVersion != 'none')
                    || (x.field != "JobSiteAccountingIntegration" && x.field != "CustomerAccountingIntegration"));
    
    if (this.exportType == ExportType.PDF)
      columns = columns.splice(0, 10);
    
    let exportObj = {
      exportData: MapExportData.mapAllCustomerdata(r.Data),
      exportHeadersColumns: columns,
      columnHeaderNotToBeIncluded: []
    }

    if (this.exportType == ExportType.Excel) {
      this.exportServ.ExportToExcel(exportObj);
    } else if (this.exportType == ExportType.PDF) {
      this.exportServ.ExportToPDF(exportObj);
    } else if (this.exportType == ExportType.CSV) {
      this.exportServ.ExportToCSV(exportObj);
    }
  }
  //#endregion
}
